<script>
import ProInput from '$common/ProInput'
import ProSelect from '$common/ProSelect'
import courses from '@/global/js/courses'
export default {
  name: 'CreateClass',
  components: {
    'pro-input': ProInput,
    'pro-select': ProSelect,
  },
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      classData : {
        course_id: '',
        month: '',
        time: '',
        time_start: '',
        time_end: '',
        day: '',
        details: '',
        details_array: [],
        date_start: '',
        date_end: '',
        done: false,
        courseType: ''
      },
      numberOfSessions: this.options.info ? this.options.info.details_array.length : 4,
      formOptions: {
        courseType: {
          title: 'Course Type',
          type: 'select',
          errorIf: (val) => val ? '' : 'Select Course Type',
        },
        course_id: {
          title: 'Course',
          type: 'select',
          errorIf: (val) => val ? '' : 'Select Course',
        },
        day: {
          title: 'Day of the week',
          type: 'select',
          errorIf: (val) => val ? '' : 'Select Day',
        },
        time_start: {
          title: 'Start Time',
          type: 'time',
          errorIf: (val) => val ? '' : 'Enter a Start Time',
        },
        time_end: {
          title: 'End Time',
          type: 'time',
          errorIf: (val) => val ? '' : 'Enter an End Time',
        },
        numberOfSessions: {
          title: 'Number of Sessions',
          type: 'number',
          errorIf: val => Number(val) < 1 ? 'Must have at least 1 session' : ''
        },
      },
      courses,
      days: ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'],
      saving: false,
      editing: false,
      filterFunc: _ => true
    }
  }, 
  methods: {
    async onSubmit() {
      const errors = await this.getErrors()
      if (errors.length) return errors.forEach(err => this.$toast({copy: err, class: 'alert'}))

      this.saving = true
      // set time
      this.classData.time = `${this.get12hTime(this.classData.time_start)} - ${this.get12hTime(this.classData.time_end)}`

      // get month from first class date
      this.classData.month = this.getMonth(this.classData.details_array[0])
      // set details class dates string
      this.classData.details = this.classData.details_array
                                  .map(date => `${date.split('-')[1]}/${date.split('-')[2]}`)
                                  .join(', ')
      // set start and end dates
      this.classData.date_start = this.classData.details_array[0]
      this.classData.date_end = this.classData.details_array[this.classData.details_array.length - 1]
      
      const classRef = this.$firestore.collection('classes')
      const classId = this.editing ? this.options.info.id : this.$firestore.collection('classes').doc().id

      if (this.editing) {
        await classRef.doc(classId).update({...this.classData})
      } else {
        try {
         await classRef.doc(classId).set({
           id: classId,
           ...this.classData
         })
        } catch (e) {
          console.error(`Failed to create new class.`,e)
          this.$toast({copy: e, class: 'alert'})
          return
        }
      }

      this.$toast({copy: `Class ${this.editing ? 'edited' : 'created'}!`})
      this.$modals.hide('create-class')

    },
    getErrors () {
      return new Promise(async (resolve, reject) => {
        const checkErrorIfs = () => Object.keys(this.formOptions)
          .map(key => this.formOptions[key].errorIf(key === 'numberOfSessions' ? this.numberOfSessions : this.classData[key]))
          .filter(Boolean)

        let classErrors = checkErrorIfs()
        if (!this.classData.details_array.length || this.classData.details_array.includes(undefined)) classErrors.push('Enter Dates for Class Sessions')

        resolve([
          ...classErrors,
        ])
      })
    },
    createOptions (key) {
      let list
      if (key == 'day') list = this.days
      else if (key == 'courseType') list = ['youth', 'adult']
      else if (key == 'course_id') {
        list = Object.keys(courses).filter(this.filterFunc).map(id => ({value: id, name: courses[id].name}))
        console.log('list: ', list)
        return list
      }
      else console.log('unkown key',key)
      return list.map(str => ({value: str, name: str}))
    },
    getDateInputOptions (n) {
      return {
        title: `Class Session ${n} Date`,
        type: 'date',
        errorIf: val => val ? '' : 'Enter start date'
      }
    },
    get12hTime (time24) {
      //expecting time24 to be in 24 hour format: "hh:mm"
      let meridiem = "am"
      let hour = Number(time24.split(':')[0])
      if (hour >= 12) {
        meridiem = "pm"
        if (hour > 12) hour -= 12
      } else if (hour == 0) hour = 12
      return `${hour}:${time24.split(':')[1]}${meridiem}`
    },
    getMonth (date) {
      const monthNum = date.split('-')[1]
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      return months[Number(monthNum)-1]
    },
  },
  async mounted () {
    if (this.options.info) {
      this.editing = true
      Object.keys(this.classData).forEach(key => {
        this.classData[key] = this.options.info[key]
      })
    }
    this.$proOn('input',payload => {
      let data = payload
      if (['adult', 'youth'].includes(data)) {
        this.classData['courseType'] = data
        this.filterFunc = key => {
          console.log('key', key)
          return this.courses[key].courseType == this.classData['courseType']
        }
        console.log("Before update: ", this.classData)
        this.formOptions['course_id']['options'] = this.createOptions('course_id')
        let currentKey = this.formOptions['course_id']['key']
        this.formOptions['course_id']['key'] = currentKey // hacky way to force update the list
      }
    })
  }
}

</script>
<template lang="pug">
  #class-main.modal-main
    .class-container.modal-container
      .title {{editing ? "Edit" : "Create"}} Class
      .content
        .pro-form
          .form-row(
            v-for='(options, key, idx) in formOptions'
          )
            pro-select(
              v-if='options.type=="select"'
              :options='createOptions(key)'
              :title='options.title'
              :key='key'
              v-model='classData[key]'
            )
            pro-input(
              v-else-if='key == "numberOfSessions"'
              :options='options'
              v-model='numberOfSessions'
            )
            pro-input(
              v-else
              :options='options'
              v-model='classData[key]'
            )
          .form-row(
            v-for='n in Number(numberOfSessions)'
          )
            pro-input(
              :options='getDateInputOptions(n)'
              v-model='classData.details_array[n-1]'
            )
          .form-row
            .pro-button.minor(
              v-if='editing'
              @click='classData["done"] = !classData["done"]'
            ) Mark as {{classData["done"] ? 'not ' : ''}}done
      .action
        .button.minor(
          @click='$modals.hide("create-class")'
        ) Cancel
        span
        .button.major(
          @click='onSubmit'
        ) {{saving ? "Saving..." : "Save Class"}}
</template>